<template>
  <div class="main">
    <h2>お探しのページは存在いたしません</h2>
  </div>
</template>
<script>
import Mixin from '@/components/mixin/Mixin'
export default {
  name: 'NotFound',
  mixins: [Mixin],
  created: function () {
    this.setScreen({ isLogoOnly: true })
  },
}
</script>
<style lang="sass" scoped>
@import '../assets/css/logico2'
.main
  height: 400px
  text-align: center
  padding-top: 160px
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue